<script setup lang="ts">
import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { VIcons } from '@/shared/ui'
import { type PropType, reactive, watch } from 'vue'

const props = defineProps({
  field: {
    type: Object as PropType<ObjectInventoryField>,
    required: true,
  },
  hideMandatory: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update'])

const currentValues = reactive({
  items: props.field?.items || [],
  mandatory: Boolean(props.field?.mandatory),
})

/**
 * Функция добавления элемента списка
 */
const addHandler = () => {
  currentValues.items.push({
    id: currentValues.items.length + 1,
    name: '',
  })
}

/**
 * Функция удаления элемента списка
 * @param id
 */
const deleteHandler = (id: number) => {
  currentValues.items = currentValues.items.filter((item) => item.id !== id)
  currentValues.items.map((item, key) => (item.id = key + 1))
}

/** Обновляем данные поля */
watch(currentValues, () => {
  emits('update', { ...props.field, ...currentValues })
})
</script>

<template>
  <VTable>
    <thead>
      <tr>
        <th width="80%">{{ $t('itf.name_label') }}</th>
        <th width="20%">{{ $t('itf.action') }}</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="item in field?.items || []" :key="item.id">
        <td>
          <VTextField v-model="item.name" :label="$t('itf.name_label')" hide-details />
        </td>
        <td>
          <VBtn icon density="compact" color="error" @click="deleteHandler(item.id)">
            <VIcons type="delete" />
          </VBtn>
        </td>
      </tr>
    </tbody>

    <VCheckbox
      v-if="!hideMandatory"
      class="ml-3"
      v-model="currentValues.mandatory"
      :label="$t('itf.required')"
    />
  </VTable>

  <div class="my-4">
    <VBtn to="#" color="default" @click="addHandler">{{ $t('itf.add_field') }}</VBtn>
  </div>
</template>
